import React from 'react';
import '../styles/AdminPanel.css';

const AdminSettingsModal = ({ onClose, textColor, setTextColor, btnColor, setBtnColor, backgroundId, setBackgroundId }) => {

    const colors = [
        "#FFFFFF", "#000000", "#FF0000", "#00FF00", "#0000FF",
        "#FFFF00", "#FF00FF", "#00FFFF", "#FFA500", "#800080",
        "#008000", "#FFC0CB", "#A52A2A", "#808080", "#FFD700"
    ];

    const backgrounds = Array.from({ length: 13 }, (_, i) => i + 1);

    const handleSave = (key, value, setter) => {
        setter(value);
        localStorage.setItem(key, value);
    };

    return (
        <div className="admin-modal-overlay">
            <div className="admin-settings-card">
                <div className="modal-header">
                    <h2>Configuración de Interfaz Admin</h2>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>

                <div className="modal-body">
                    <section className="setting-section">
                        <h3>Color del Texto</h3>
                        <div className="color-grid">
                            {colors.map(color => (
                                <div
                                    key={color}
                                    className={`color-swatch ${textColor === color ? 'selected' : ''}`}
                                    style={{ backgroundColor: color }}
                                    onClick={() => handleSave('adminTextColor', color, setTextColor)}
                                />
                            ))}
                        </div>
                    </section>

                    <section className="setting-section">
                        <h3>Color de los Botones</h3>
                        <div className="color-grid">
                            {colors.map(color => (
                                <div
                                    key={color}
                                    className={`color-swatch ${btnColor === color ? 'selected' : ''}`}
                                    style={{ backgroundColor: color }}
                                    onClick={() => handleSave('adminBtnColor', color, setBtnColor)}
                                />
                            ))}
                        </div>
                    </section>

                    <section className="setting-section">
                        <h3>Fondo de Pantalla</h3>
                        <div className="bg-grid">
                            {backgrounds.map(id => (
                                <div
                                    key={id}
                                    className={`bg-swatch style-${id} ${backgroundId === id ? 'selected' : ''}`}
                                    onClick={() => handleSave('adminBgId', id, setBackgroundId)}
                                >
                                    <span>{id}</span>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>

                <div className="modal-footer">
                    <button className="save-btn" onClick={onClose}>Cerrar y Aplicar</button>
                </div>
            </div>
        </div>
    );
};

export default AdminSettingsModal;
